/** A ponte entre "abrir projeto pelo card do CRM" (Tarefa 14) e "mostrar o
 * quadro" (Tarefa 13, `App.tsx`).
 *
 * Mesmo caminho de `features/board/atalhoDeCriacao.ts`: quem cria o projeto
 * está no fundo da árvore — dentro do painel da oportunidade, aberto pelo
 * funil ou pela agenda — e quem decide qual tela aparece é a área logada, no
 * topo. Um evento no `window` liga os dois sem obrigar `PainelDaOportunidade`
 * a saber que existe um quadro de entregas, nem `QuadroDeOportunidades` e
 * `Agenda` — que abrem o painel hoje — a carregar mais uma prop que só
 * repassariam.
 */

export const EVENTO_DE_ABERTURA_DO_QUADRO = "tanzuh:abrir-quadro-de-entregas";

export function pedirAberturaDoQuadro(projetoId: string): void {
  window.dispatchEvent(
    new CustomEvent<string>(EVENTO_DE_ABERTURA_DO_QUADRO, { detail: projetoId }),
  );
}

/** O id do projeto pedido, ou `null` se o evento não for o nosso — mesma
 * forma de `abreCriacao`: função pura, testável sem montar o `window`. */
export function projetoPedido(evento: Event): string | null {
  if (evento.type !== EVENTO_DE_ABERTURA_DO_QUADRO) return null;
  const detalhe = (evento as CustomEvent<unknown>).detail;
  return typeof detalhe === "string" && detalhe !== "" ? detalhe : null;
}
